import type { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import {
    GET_WARBOX_GALLERY_MESSAGES_BY_CONVERSATION,
    GET_WARBOX_MESSAGES_BY_CONVERSATION,
    SET_GALLERY_LOADING,
} from '../constants/actions';
import type {
    TGetMessagesByConversationOptions,
    TWarboxMessageActionTypes,
} from '../types';
import type { IMessage } from 'src/interfaces/message';

export const getMessagesByConversation = async (
    dispatch: Dispatch<TWarboxMessageActionTypes>,
    conversationId: string,
    filters: Record<string, unknown> = {},
    options: TGetMessagesByConversationOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
        storeTarget: 'messages',
    }
): Promise<void> => {
    const storeTarget = options.storeTarget ?? 'messages';

    if (storeTarget === 'gallery') {
        dispatch({ type: SET_GALLERY_LOADING, payload: true });
    } else {
        dispatch({ type: SET_LOADING });
    }

    try {
        const config = HEADERS({
            isReadPermissionNecessary:
                options.isReadPermissionNecessary ?? false,
        });
        const res = await ApiV2.post(
            `/conversations/${conversationId}/messages`,
            filters,
            config
        );

        const messages: IMessage[] = res.data?.data ?? [];
        const total =
            res.data?.pagination?.total ?? res.data?.count ?? messages.length;

        if (storeTarget === 'gallery') {
            dispatch({
                type: GET_WARBOX_GALLERY_MESSAGES_BY_CONVERSATION,
                payload: { messages, total },
            });
            return;
        }

        dispatch({
            type: GET_WARBOX_MESSAGES_BY_CONVERSATION,
            payload: {
                messages,
                total,
                mergeStrategy: options.mergeStrategy,
            },
        });
    } catch (error) {
        if (storeTarget === 'gallery') {
            dispatch({
                type: GET_WARBOX_GALLERY_MESSAGES_BY_CONVERSATION,
                payload: { messages: [], total: 0 },
            });
        } else {
            dispatch({
                type: GET_WARBOX_MESSAGES_BY_CONVERSATION,
                payload: {
                    messages: [],
                    total: 0,
                    mergeStrategy: options.mergeStrategy,
                },
            });
        }

        if (error instanceof Error) dispatch(handleError(error));
    }
};
